<template lang="pug">
    // Text-and-pill variant (legacy) used by other screens.
    v-btn.button.mr-0.pr-0(
        v-if="!iconOnly"
        @click.stop="action"
        flat
    )
        span.white--text {{ $t('general.back')}}
        v-btn.closeIcon(
            icon
            light
            small
            color="white"
        )
            v-icon(size="16" color="black") arrow_back

    // Icon-only variant — a clean 40x40 transparent tap target with
    // a white chevron. Used in the session header so the back control
    // sits visually alongside the title without a competing pill shape.
    v-btn.backIconOnly(
        v-else
        @click.stop="action"
        icon
        aria-label="Back"
    )
        v-icon(color="white" size="22") arrow_back
</template>

<script>
    import VueTypes from 'vue-types';

    export default {
        props: {
            route: VueTypes.object.def({}),
            back: VueTypes.bool.def(false),
            // When true, render the circular arrow only (no "BACK" label).
            // Used on ViewSession so the back control sits inline with the
            // session title on a single row.
            iconOnly: VueTypes.bool.def(false)
        },
        methods: {
            action() {
                if (this.back) return this.$router.go(-1);
                return this.$router.push(this.route).catch(() => {});
            }
        }
    };
</script>

<style lang="stylus" scoped>
    .icon
        font-size: 20px;
        margin: 0

    .backIconOnly
        width: 40px
        height: 40px
        min-width: 40px !important
        margin: 0
        padding: 0
        background: transparent !important
        // Very subtle hover / press affordance so the arrow doesn't feel
        // floating in space but also doesn't introduce a competing pill.
        border-radius: 50%
        &:hover, &:focus
            background: rgba(255, 255, 255, 0.08) !important
</style>
